import { MY_TEAMS_ADVISOR } from '@zet/constants'
import { APP_NAME } from '@zet/end-points'
import { zetApi } from '@zet/network'

export async function getLeadsReport(
  dateRange: {
    to: string
    from: string
  },
  isMyTeamsReq: boolean
) {
  return new Promise((resolve, reject) => {
    fetch(
      `${zetApi.defaults.baseURL}lead/getLeadsByDate/v2?fromDate=${dateRange.from}&toDate=${dateRange.to}&isMyTeamsReq=${isMyTeamsReq}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            zetApi.defaults.headers.common['Authorization']?.toString() || '',
          locale: 'en',
          ...(APP_NAME === MY_TEAMS_ADVISOR ? { appSource: 'bridge' } : {}),
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        resolve(data?.data)
      })
      .catch((err) => {
        reject(err)
      })
  })

  // TODO: Timeout doesn't work with Axios for some reason. Need to check this.
  // const { data } = await zetApi.get<ILeadReport>(
  //   `lead/getLeadsByDate/v2?fromDate=${dateRange.from}&toDate=${dateRange.to}&isMyTeamsReq=${isMyTeamsReq}`
  // )
  // return data?.data
}
